import React, { useEffect, useState } from 'react'
import TeethContainer from './TeethContainer'
import { allTeeth } from './ateeth'
import baseUrl from '../../../../../../../../api/baseUrl';
import DiagnoseItem from '../diaggnoseitem/DiagnoseItem';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addAdvancedDiagnose, addDiagnose, updateAdvancedDiagnose, updateAdvancedDiagnoseBridge } from '../../../../../../../../redux/diagnosestate/diagnoseAction';
import { toast } from 'react-toastify';
import { RootState } from '../../../../../../../../redux/store';
const defaultDiagnoses = [
    {
        diagnose: "missing",
        color: "#000",
        isBtn: true,
        hasSurface: false,
        _id: "1",
    },
    {
        diagnose: "Abration",
        color: "#f1c40f",
        isBtn: true,
        hasSurface: true,
        _id: "2",
    },
    {
        diagnose: "Fracture",
        color: "red",
        isBtn: true,
        hasSurface: true,
        _id: "3",
    },
    {
        diagnose: "Attrition",
        color: "blue",
        isBtn: true,
        hasSurface: true,
        _id: "4",
    },
    {
        diagnose: "Caries",
        color: "green",
        isBtn: true,
        hasSurface: true,
        _id: "5",
    },
];
function ToothDiagnoseModal({ isOpen, onClose, tooth, upsideDown, rowNumber }: { isOpen: boolean, onClose: () => void, tooth: any, upsideDown: boolean, rowNumber: number }) {
    const [diagnosisData, setDiagnosisData] = useState<any[]>([]);
    const [color, setcolor] = useState("");
    const [diagnoses, setdiagnoses] = useState<any>({});
    const { ID } = useParams();
    const dispatch = useDispatch();
    const getDiagnosisData = () => {
        baseUrl
            .get("alltreatment/findAllDiagnose", {
                headers: {
                    status: true,
                },
            })
            .then((response) => {
                setDiagnosisData(response.data.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    useEffect(() => {
        if (isOpen) {
            getDiagnosisData();
        }
    }, [isOpen]);
    const [rootDiagnoses, setRootDiagnoses] = useState<string>("");
    const [individualRootVariants, setIndividualRootVariants] = useState<string[]>([]);
    const [diagnoseType, setdiagnoseType] = useState("")
    const [note, setNote] = useState<string>("");
    const [bridgeType, setBridgeType] = useState<string>("");
    const [bridgeTooth1, setBridgeTooth1] = useState<number | "">("");
    const [bridgeTooth2, setBridgeTooth2] = useState<number | "">("");
    const diagnoseTeeth = useSelector((state: RootState) => state.diagnose.advancedDiagnose);
    const advancedDiagnose = useSelector((state: RootState) => state.diagnose.advancedDiagnose);
    const diagnoseTooth = useSelector((state: RootState) => state.diagnose.diagnoseTooth);
    const validAdvancedDiagnose = Array.isArray(advancedDiagnose)
        ? advancedDiagnose.filter((adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === 'number')
        : [];
    const existingAdvancedDiagnose = validAdvancedDiagnose.length > 0
        ? validAdvancedDiagnose.find((adv: any) => adv.toothNo === tooth.toothNo)
        : null;
    const toothWithApiData = React.useMemo(() => {
        if (!existingAdvancedDiagnose) {
            return tooth;
        }

        // Merge surface data from API
        let mergedSurface = tooth.surface || [];
        if (existingAdvancedDiagnose.surface && Array.isArray(existingAdvancedDiagnose.surface)) {
            // Map API surface data to tooth surface structure by sid
            mergedSurface = (tooth.surface || []).map((surf: any) => {
                const apiSurface = existingAdvancedDiagnose.surface.find(
                    (s: any) => String(s.sid) === String(surf?.sid)
                );
                if (apiSurface) {
                    return {
                        ...surf,
                        color: apiSurface.color || surf.color,
                        diagnose: apiSurface.diagnose,
                        diagnoseId: apiSurface.diagnoseId,
                    };
                }
                return surf;
            });
        }

        // Create rootDiagnoses object for TeethContainer using current state
        const rootDiagnosesData = {
            forceRedColor: false,
            hideRoot: rootDiagnoses === "hide",
            useImplantSVG: rootDiagnoses === "implant",
            rotate35: rootDiagnoses === "left", // Left rotation -35deg
            rotateRight35: rootDiagnoses === "right", // Right rotation +35deg
            individualRootVariants: individualRootVariants,
        };

        return {
            ...tooth,
            surface: mergedSurface,
            rootDiagnoses: rootDiagnosesData,
            condition: existingAdvancedDiagnose.condition, // Pass condition to TeethContainer
        };
    }, [tooth, existingAdvancedDiagnose, individualRootVariants, rootDiagnoses]);

    useEffect(() => {
        const diagnoseTooth = diagnoseTeeth.filter((t: any) => t.toothNo === tooth.toothNo);

        // Load existing rootDiagnoses and rootVariantDiagnoses from advancedDiagnose when modal opens
        if (isOpen) {
            // Filter out template objects
            const validAdvancedDiagnose = Array.isArray(advancedDiagnose)
                ? advancedDiagnose.filter((adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === 'number')
                : [];
            const existingAdvancedDiagnose = validAdvancedDiagnose.length > 0
                ? validAdvancedDiagnose.find((adv: any) => adv.toothNo === tooth.toothNo)
                : null;

            // Load rootDiagnoses
            if (existingAdvancedDiagnose?.rootDiagnoses) {
                setRootDiagnoses(existingAdvancedDiagnose.rootDiagnoses);
            } else {
                setRootDiagnoses("");
            }

            // Load rootVariantDiagnoses and map to individualRootVariants
            if (existingAdvancedDiagnose?.rootVariantDiagnoses && Array.isArray(existingAdvancedDiagnose.rootVariantDiagnoses)) {
                // Initialize array with "plain" for all roots
                const variants = new Array(tooth.root?.length || 0).fill("plain");

                // Map existing rootVariantDiagnoses to the array by rootNo
                existingAdvancedDiagnose.rootVariantDiagnoses.forEach((variant: any) => {
                    if (variant.rootNo !== undefined && variant.diagnose) {
                        const rootIndex = tooth.root?.findIndex((r: any) => String(r.rootNo) === String(variant.rootNo));
                        if (rootIndex !== -1) {
                            variants[rootIndex] = variant.diagnose;
                        }
                    }
                });

                setIndividualRootVariants(variants);
            } else {
                // Initialize with "plain" for all roots
                setIndividualRootVariants(new Array(tooth.root?.length || 0).fill("plain"));
            }

            // Load note
            if (existingAdvancedDiagnose?.note) {
                setNote(existingAdvancedDiagnose.note);
            } else {
                setNote("");
            }

            // Load bridge from advancedDiagnose (matches DB: bridge.bridgeType, bridge.lefttooth, bridge.righttooth)
            const b = existingAdvancedDiagnose?.bridge;
            if (b?.bridgeType) {
                setBridgeType(b.bridgeType);
                setBridgeTooth1(b.lefttooth ?? "");
                setBridgeTooth2(b.righttooth ?? "");
            } else {
                setBridgeType("");
                setBridgeTooth1("");
                setBridgeTooth2("");
            }
        }
    }, [diagnoseTeeth, isOpen, advancedDiagnose, tooth.toothNo, tooth.root]);
    // Helper function to update Redux advancedDiagnose
    const updateReduxAdvancedDiagnose = (updates: any) => {
        // Filter out template objects and find the actual entry
        const validAdvancedDiagnose = Array.isArray(advancedDiagnose)
            ? advancedDiagnose.filter((adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === 'number')
            : [];

        const currentAdvancedDiagnose = validAdvancedDiagnose.length > 0
            ? validAdvancedDiagnose.find((adv: any) => adv.toothNo === tooth.toothNo)
            : null;

        // Merge updates with existing data
        let updatedAdvancedDiagnose: any;

        if (currentAdvancedDiagnose) {
            // Update existing entry - create new object without mutating
            updatedAdvancedDiagnose = { ...currentAdvancedDiagnose };

            // Apply updates
            if (updates.surface !== undefined) {
                updatedAdvancedDiagnose.surface = updates.surface;
            }
            if (updates.rootVariantDiagnoses !== undefined) {
                updatedAdvancedDiagnose.rootVariantDiagnoses = updates.rootVariantDiagnoses;
            }
            if (updates.rootDiagnoses !== undefined) {
                if (updates.rootDiagnoses === null) {
                    // Remove rootDiagnoses by creating new object without it
                    const { rootDiagnoses, ...rest } = updatedAdvancedDiagnose;
                    updatedAdvancedDiagnose = rest;
                } else {
                    updatedAdvancedDiagnose.rootDiagnoses = updates.rootDiagnoses;
                }
            }
            if (updates.condition !== undefined) {
                if (updates.condition === null || updates.condition === undefined || updates.condition === "") {
                    // Remove condition by creating new object without it
                    // Check if condition exists in the object before removing
                    if ('condition' in updatedAdvancedDiagnose) {
                        const { condition, ...rest } = updatedAdvancedDiagnose;
                        updatedAdvancedDiagnose = rest;
                    }
                } else {
                    updatedAdvancedDiagnose.condition = updates.condition;
                }
            }
            if (updates.note !== undefined) {
                updatedAdvancedDiagnose.note = updates.note;
            }
        } else {
            // Create new entry
            updatedAdvancedDiagnose = {
                toothNo: tooth.toothNo,
                surface: updates.surface || [],
                rootVariantDiagnoses: updates.rootVariantDiagnoses || [],
            };

            if (updates.rootDiagnoses !== undefined && updates.rootDiagnoses !== null) {
                updatedAdvancedDiagnose.rootDiagnoses = updates.rootDiagnoses;
            }
            if (updates.condition !== undefined && updates.condition !== null) {
                updatedAdvancedDiagnose.condition = updates.condition;
            }
            if (updates.note !== undefined && updates.note !== null) {
                updatedAdvancedDiagnose.note = updates.note;
            }
        }
        dispatch(updateAdvancedDiagnose(updatedAdvancedDiagnose));
    };
    const handleDiagnoseClick = (e: any) => {
        setcolor(e?.color);
        setdiagnoses(e);

    };
    const handleMissingToothClick = (e: any) => {
        // Find the surface with "missing" diagnose
        const validAdvancedDiagnose = Array.isArray(advancedDiagnose)
            ? advancedDiagnose.filter((adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === 'number')
            : [];
        const currentAdvancedDiagnose = validAdvancedDiagnose.length > 0
            ? validAdvancedDiagnose.find((adv: any) => adv.toothNo === tooth.toothNo)
            : null;

        const missingSurface = currentAdvancedDiagnose?.surface?.find(
            (s: any) => s.diagnose?.toLowerCase() === "missing"
        );

        if (missingSurface) {
            // Clear the missing surface - backend will automatically clear condition if it's "missing"
            const sidValue = missingSurface.sid;
            baseUrl.post("treatment/update-surface-diagnose", {
                toothNo: tooth.toothNo,
                color: "",
                diagnose: "clear",
                diagnoseId: "",
                sid: sidValue,
                hasSurface: false,
            }, {
                headers: {
                    treatmentid: ID,
                },
            }).then((response) => {
                if (response.data.success) {
                    // Update Redux state - remove the surface and clear condition
                    const updatedSurface = (currentAdvancedDiagnose?.surface || []).filter(
                        (s: any) => String(s.sid) !== String(sidValue)
                    );

                    // Remove condition from Redux (set to null so it gets removed)
                    updateReduxAdvancedDiagnose({
                        surface: updatedSurface,
                        condition: null
                    });
                    toast.success("Missing condition cleared successfully");
                }
            }).catch((error) => {
                console.log(error);
                toast.error(error.response?.data?.message || "Failed to clear missing condition");
            });
        } else {
            // If no missing surface found, just clear the condition
            baseUrl.post("treatment/add-advanced-diagnose", {
                toothNo: tooth.toothNo,
                condition: null, // Send null to clear condition
            }, {
                headers: {
                    treatmentid: ID,
                },
            }).then((conditionResponse) => {
                if (conditionResponse.data.success) {
                    updateReduxAdvancedDiagnose({
                        condition: null // Remove condition from Redux
                    });
                    toast.success("Missing condition cleared successfully");
                }
            }).catch((error) => {
                console.log(error);
                toast.error(error.response?.data?.message || "Failed to clear condition");
            });
        }
    };
    const onhandleClick = (e: any) => {
        const sidValue = e?.sid?.sid || e?.sid;

        baseUrl.post("treatment/update-surface-diagnose", {
            toothNo: tooth.toothNo,
            color: color,
            diagnose: diagnoses?.diagnose,
            diagnoseId: diagnoses?._id,
            sid: sidValue,
            hasSurface: diagnoses?.hasSurface,

        }, {
            headers: {
                treatmentid: ID,
            },
        }).then((response) => {
            console.log(response);
            if (response.data.success) {
                // Update Redux state
                const validAdvancedDiagnose = Array.isArray(advancedDiagnose)
                    ? advancedDiagnose.filter((adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === 'number')
                    : [];
                const currentAdvancedDiagnose = validAdvancedDiagnose.length > 0
                    ? validAdvancedDiagnose.find((adv: any) => adv.toothNo === tooth.toothNo)
                    : null;

                const currentSurface = currentAdvancedDiagnose?.surface || [];
                const isClear = !diagnoses?.diagnose || diagnoses?.diagnose?.toLowerCase() === "clear";
                const isMissing = diagnoses?.diagnose?.toLowerCase() === "missing";

                let updatedSurface = [...currentSurface];
                let updates: any = {};

                if (isClear) {
                    // Remove surface by sid
                    updatedSurface = updatedSurface.filter((s: any) => String(s.sid) !== String(sidValue));
                    updates.surface = updatedSurface;
                } else if (isMissing) {
                    // If diagnose is "missing", set condition and keep only this surface
                    updates.condition = "missing";
                    updates.surface = [{
                        sid: sidValue,
                        color: color,
                        diagnose: diagnoses?.diagnose,
                        diagnoseId: diagnoses?._id,
                    }];
                } else {
                    // Add or update surface
                    const existingSurfaceIndex = updatedSurface.findIndex(
                        (s: any) => String(s.sid) === String(sidValue)
                    );
                    const newSurface = {
                        sid: sidValue,
                        color: color,
                        diagnose: diagnoses?.diagnose,
                        diagnoseId: diagnoses?._id,
                    };

                    if (existingSurfaceIndex !== -1) {
                        updatedSurface[existingSurfaceIndex] = newSurface;
                    } else {
                        updatedSurface.push(newSurface);
                    }
                    updates.surface = updatedSurface;

                    // If condition was "missing" but now it's not, clear the condition
                    if (currentAdvancedDiagnose?.condition === "missing") {
                        updates.condition = undefined; // Will be removed in updateReduxAdvancedDiagnose
                    }
                }

                updateReduxAdvancedDiagnose(updates);
                toast.success(response.data.message || "Surface diagnose updated successfully");
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "Failed to update surface diagnose");
        });
    };
    const onhandleRootDiagnosisChange = (e: any) => {
        const value = e.target.value;
        const checked = e.target.checked;

        // If checked, set the value (this will automatically uncheck others since only one can match)
        // If unchecked, clear it (allow all to be unchecked)
        const newValue = checked ? value : "";

        // Update local state
        setRootDiagnoses(newValue);

        baseUrl.post("treatment/update-root-diagnoses", {
            toothNo: tooth.toothNo,
            rootDiagnoses: value,
            add: checked
        }, {
            headers: {
                treatmentid: ID,
            },
        }).then((response) => {
            console.log(response);
            if (response.data.success) {
                // Update Redux state (use null when unchecked so merge logic removes rootDiagnoses)
                const rootDiagnosesValue = checked ? value : null;
                const updates: any = { rootDiagnoses: rootDiagnosesValue };
                updateReduxAdvancedDiagnose(updates);
                toast.success(response.data.message || "Root diagnoses updated successfully");
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "Failed to update root diagnoses");
        });
    };
    const onhandleRootVariantChange = (rootNo: number, value: string) => {
        // Find the index of the root in the tooth.root array
        const rootIndex = tooth.root?.findIndex((r: any) => String(r.rootNo) === String(rootNo));

        if (rootIndex !== -1) {
            // Update local state
            setIndividualRootVariants((prev) => {
                const updated = [...prev];
                // Ensure array is long enough
                while (updated.length <= rootIndex) {
                    updated.push("plain");
                }
                updated[rootIndex] = value;
                return updated;
            });
        }

        // Update backend
        baseUrl.post("treatment/update-root-variant-diagnoses", {
            toothNo: tooth.toothNo,
            diagnose: value,
            rootNo: rootNo,
        }, {
            headers: {
                treatmentid: ID,
            },
        }).then((response) => {
            if (response.data.success) {
                const validAdvancedDiagnose = Array.isArray(advancedDiagnose)
                    ? advancedDiagnose.filter((adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === 'number')
                    : [];
                const currentAdvancedDiagnose = validAdvancedDiagnose.length > 0
                    ? validAdvancedDiagnose.find((adv: any) => adv.toothNo === tooth.toothNo)
                    : null;

                const currentRootVariantDiagnoses = currentAdvancedDiagnose?.rootVariantDiagnoses || [];
                const existingIndex = currentRootVariantDiagnoses.findIndex(
                    (r: any) => String(r.rootNo) === String(rootNo)
                );

                let updatedRootVariantDiagnoses = [...currentRootVariantDiagnoses];
                if (existingIndex !== -1) {
                    // Update existing
                    updatedRootVariantDiagnoses[existingIndex] = {
                        rootNo: rootNo,
                        diagnose: value,
                    };
                } else {
                    // Add new
                    updatedRootVariantDiagnoses.push({
                        rootNo: rootNo,
                        diagnose: value,
                    });
                }

                updateReduxAdvancedDiagnose({
                    rootVariantDiagnoses: updatedRootVariantDiagnoses
                });
                toast.success(response.data.message || "Root variant diagnosis updated successfully");
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "Failed to update root variant diagnosis");
        });
    };
    const handleSave = () => {
        // Save bridge data using dedicated endpoint
        const bridge = {
            bridgeType: bridgeType || undefined,
            lefttooth: bridgeTooth1 !== "" ? (bridgeTooth1 as number) : undefined,
            righttooth: bridgeTooth2 !== "" ? (bridgeTooth2 as number) : undefined,
        };

        // Only save if bridge has at least one field
        if (bridge.bridgeType || bridge.lefttooth || bridge.righttooth) {
            baseUrl
                .post("treatment/update-advanced-diagnose-bridge", {
                    toothNo: tooth.toothNo,
                    bridge: bridge,
                }, {
                    headers: { treatmentid: ID },
                })
                .then((response) => {
                    if (response.data.success) {
                        toast.success("Bridge saved successfully");
                        onClose();
                    } else {
                        toast.error(response.data.message || "Failed to save bridge");
                    }
                })
                .catch((error) => {
                    console.error("Error saving bridge:", error);
                    toast.error(error.response?.data?.message || "Failed to save bridge");
                });
        } else {
            // No bridge data to save, just close
            onClose();
        }
    };

    const handleNoteChange = (noteValue: string) => {
        baseUrl.post("treatment/update-advanced-diagnose-note", {
            toothNo: tooth.toothNo,
            note: noteValue || "",
        }, {
            headers: {
                treatmentid: ID,
            },
        }).then((response) => {
            if (response.data.success) {
                updateReduxAdvancedDiagnose({
                    note: noteValue || ""
                });
                toast.success(response.data.message || "Note updated successfully");
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "Failed to update note");
        });
    };

    return (
        <div className={`tooth-diagnose-modal fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-3 sm:p-4 md:p-6 overflow-y-auto ${isOpen ? 'block' : 'hidden'}`}>
            <div className='tooth-diagnose-modal-content bg-white rounded-lg shadow-xl w-full max-w-[95vw] sm:max-w-xl md:max-w-2xl lg:max-w-4xl max-h-[95vh] sm:max-h-[90vh] flex flex-col z-[9999] my-auto'>
                <div className='relative flex justify-between items-center px-3 py-2 sm:px-4 sm:py-2 md:px-5 md:py-2.5 border-b border-slate-200 flex-shrink-0'>
                    <h2 className='text-sm sm:text-base md:text-lg font-semibold text-slate-800 truncate pr-10'>Tooth {tooth.toothNo} - Diagnose</h2>
                    <button className='text-slate-500 hover:text-slate-700 text-xl sm:text-2xl absolute right-3 sm:right-4 md:right-5 top-1/2 -translate-y-1/2' onClick={onClose} aria-label="Close">×</button>
                </div>
                <div className='flex flex-col md:flex-row flex-1 min-h-0 overflow-y-auto md:overflow-auto gap-3 sm:gap-4 p-3 sm:p-4 md:p-5'>
                    <div className='flex flex-col flex-shrink-0 w-full md:min-w-[260px] md:w-1/2 lg:min-w-[300px] justify-center items-center min-h-[240px] sm:min-h-[280px] md:min-h-[320px] lg:min-h-[360px] overflow-auto order-1 md:order-none'>
                        <TeethContainer
                            onhandleClick={toothWithApiData?.condition === "missing" ? handleMissingToothClick : onhandleClick}
                            rotate={upsideDown}
                            tooth={toothWithApiData}
                            className='scale-[120%] sm:scale-[150%] md:scale-[160%] lg:scale-[180%] xl:scale-[200%]'
                        />
                    </div>
                    <div className='flex flex-col w-full md:min-w-[260px] md:w-1/2 lg:min-w-[280px] min-h-0 md:min-h-[320px] lg:min-h-[360px] overflow-y-auto pr-0.5 order-2 md:order-none flex-1 md:flex-initial flex-shrink-0'>
                        <div className="border-b pb-3 sm:pb-4 mb-3 sm:mb-4">
                            <h4 className="text-[10px] sm:text-xs font-semibold text-slate-700 mb-1.5 sm:mb-2">
                                Select Diagnosis
                            </h4>
                            <div className="flex flex-wrap gap-1 sm:gap-1.5">
                                {defaultDiagnoses.map((item: any, i: number) => (
                                    <DiagnoseItem
                                        onClick={() => handleDiagnoseClick(item)}
                                        item={item}
                                        key={i}
                                        selected={color === item?.color}
                                    />
                                ))}
                                {diagnosisData
                                    .filter((items: any) => items.isBtn === true)
                                    .map((item: any, i: number) => (
                                        <DiagnoseItem
                                            onClick={() => handleDiagnoseClick(item)}
                                            item={item}
                                            key={`custom-${i}`}
                                            selected={color === item?.color}
                                        />
                                    ))}
                                <DiagnoseItem
                                    onClick={() =>
                                        handleDiagnoseClick({
                                            diagnose: "Clear",
                                            _id: "clear",
                                            value: "clear",
                                            color: "white",
                                            isBtn: true,
                                        })
                                    }
                                    item={{
                                        diagnose: "Clear",
                                        _id: "clear",
                                        color: "gray",
                                    }}
                                    selected={color === "white"}
                                />
                            </div>
                        </div>

                        {/* Bridge Type - matches Treatment.model: bridge.bridgeType, bridge.lefttooth, bridge.righttooth */}
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">
                                Bridge Type (Optional)
                            </label>
                            <select
                                value={bridgeType}
                                onChange={(e) => {
                                    const v = e.target.value;
                                    setBridgeType(v);
                                    if (!v) {
                                        setBridgeTooth1("");
                                        setBridgeTooth2("");
                                    }
                                    dispatch(updateAdvancedDiagnoseBridge({
                                        toothNo: tooth.toothNo,
                                        bridge: {
                                            bridgeType: v || undefined,
                                            lefttooth: v && bridgeTooth1 !== "" ? (bridgeTooth1 as number) : undefined,
                                            righttooth: v && bridgeTooth2 !== "" ? (bridgeTooth2 as number) : undefined,
                                        },
                                    }));
                                }}
                                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                            >
                                <option value="">None</option>
                                <option value="conventional-fixed">Conventional Fixed</option>
                                <option value="resin-bonded">Resin Bonded</option>
                                <option value="cantilever">Cantilever</option>
                            </select>
                        </div>

                        {bridgeType && (
                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-2">
                                Bridge Teeth 
                            </label>
                            <div className="flex items-center gap-2">
                                {(() => {
                                    const rows = [
                                        { ranges: [[0, 5], [5, 10]] },
                                        { ranges: [[10, 18], [18, 26]] },
                                        { ranges: [[26, 34], [34, 42]] },
                                        { ranges: [[42, 47], [47, 52]] },
                                    ];
                                    const currentRow = rows[rowNumber];
                                    if (!currentRow) return null;
                                    const rowTeeth: any[] = [];
                                    currentRow.ranges.forEach((range: any) => {
                                        const [start, end] = range;
                                        rowTeeth.push(...allTeeth.slice(start, end));
                                    });
                                    const currentToothRowIndex = rowTeeth.findIndex((t: any) => t.toothNo === tooth.toothNo);
                                    const leftTeeth = rowTeeth.slice(0, currentToothRowIndex).filter((t: any) => t.toothNo !== tooth.toothNo);
                                    const rightTeeth = rowTeeth.slice(currentToothRowIndex + 1).filter((t: any) => t.toothNo !== tooth.toothNo);

                                    const syncBridge = (left: number | "", right: number | "") => {
                                        dispatch(updateAdvancedDiagnoseBridge({
                                            toothNo: tooth.toothNo,
                                            bridge: {
                                                bridgeType: bridgeType || undefined,
                                                lefttooth: left !== "" ? left : undefined,
                                                righttooth: right !== "" ? right : undefined,
                                            },
                                        }));
                                    };

                                    return (
                                        <>
                                            {leftTeeth.length > 0 ? (
                                                <select
                                                    value={bridgeTooth1}
                                                    onChange={(e) => {
                                                        const val = e.target.value === "" ? "" : parseInt(e.target.value, 10);
                                                        if (val === "" || val !== bridgeTooth2) {
                                                            setBridgeTooth1(val as number | "");
                                                            syncBridge(val as number | "", bridgeTooth2);
                                                        }
                                                    }}
                                                    className="flex-1 px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                                                >
                                                    <option value="">Tooth 1</option>
                                                    {leftTeeth.map((t: any) => (
                                                        <option key={t.toothNo} value={t.toothNo} disabled={bridgeTooth2 === t.toothNo}>{t.toothNo}</option>
                                                    ))}
                                                </select>
                                            ) : <div className="flex-1 px-3 py-2 border border-slate-200 rounded-lg bg-slate-50 text-slate-400 text-sm text-center">—</div>}
                                            <span className="px-3 py-2 text-sm font-semibold text-slate-700 bg-slate-100 rounded-lg min-w-[50px] text-center">{tooth.toothNo}</span>
                                            {rightTeeth.length > 0 ? (
                                                <select
                                                    value={bridgeTooth2}
                                                    onChange={(e) => {
                                                        const val = e.target.value === "" ? "" : parseInt(e.target.value, 10);
                                                        if (val === "" || val !== bridgeTooth1) {
                                                            setBridgeTooth2(val as number | "");
                                                            syncBridge(bridgeTooth1, val as number | "");
                                                        }
                                                    }}
                                                    className="flex-1 px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                                                >
                                                    <option value="">Tooth 2</option>
                                                    {rightTeeth.map((t: any) => (
                                                        <option key={t.toothNo} value={t.toothNo} disabled={bridgeTooth1 === t.toothNo}>{t.toothNo}</option>
                                                    ))}
                                                </select>
                                            ) : <div className="flex-1 px-3 py-2 border border-slate-200 rounded-lg bg-slate-50 text-slate-400 text-sm text-center">—</div>}
                                        </>
                                    );
                                })()}
                            </div>
                        </div>
                        )}
                        {/* Root Treatment Options */}
                        <div className="border-t pt-3 sm:pt-4 mt-3 sm:mt-4">
                            <h3 className="text-xs sm:text-sm font-semibold text-slate-700 mb-2 sm:mb-3">
                                Root Treatment
                            </h3>
                            <div className="space-y-2 sm:space-y-3">
                                <div className="space-y-1.5 sm:space-y-2">
                                    {tooth.root.map((root: any, index: number) => (
                                        <div key={index} className="flex items-center gap-1.5 sm:gap-2">
                                            <label className="text-[10px] sm:text-xs text-slate-600 w-12 sm:w-16">
                                                Root {root.rootNo}:
                                            </label>
                                            <select
                                                value={individualRootVariants?.[index] || "plain"}
                                                onChange={(e) => onhandleRootVariantChange(root.rootNo, e.target.value)}
                                                className="flex-1 px-2 sm:px-3 py-1.5 sm:py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs sm:text-sm"
                                            >
                                                <option value="plain">Plain</option>
                                                <option value="Root Canal">Root Canal</option>
                                                <option value="Post & Core">Post & Core</option>
                                            </select>
                                        </div>
                                    ))}
                                </div>
                                <div className="space-y-1.5 sm:space-y-2">
                                    <div className="flex items-center gap-1.5 sm:gap-2">
                                        <input
                                            type="checkbox"
                                            id="left"
                                            value="left"
                                            checked={rootDiagnoses === "left"}
                                            onChange={onhandleRootDiagnosisChange}
                                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                                        />
                                        <label
                                            htmlFor="left"
                                            className="text-xs sm:text-sm text-slate-700 cursor-pointer"
                                        >
                                            Left Side
                                        </label>
                                    </div>
                                    <div className="flex items-center gap-1.5 sm:gap-2">
                                        <input
                                            type="checkbox"
                                            id="right"
                                            value="right"
                                            checked={rootDiagnoses === "right"}
                                            onChange={onhandleRootDiagnosisChange}
                                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                                        />
                                        <label
                                            htmlFor="right"
                                            className="text-xs sm:text-sm text-slate-700 cursor-pointer"
                                        >
                                            Right Side
                                        </label>
                                    </div>
                                    <div className="flex items-center gap-1.5 sm:gap-2">
                                        <input
                                            type="checkbox"
                                            id="hide"
                                            value="hide"
                                            checked={rootDiagnoses === "hide"}
                                            onChange={onhandleRootDiagnosisChange}
                                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                                        />
                                        <label
                                            htmlFor="hide"
                                            className="text-xs sm:text-sm text-slate-700 cursor-pointer"
                                        >
                                            Hide Root
                                        </label>
                                    </div>
                                    <div className="flex items-center gap-1.5 sm:gap-2">
                                        <input
                                            type="checkbox"
                                            id="implant"
                                            value="implant"
                                            checked={rootDiagnoses === "implant"}
                                            onChange={onhandleRootDiagnosisChange}
                                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
                                        />
                                        <label
                                            htmlFor="implant"
                                            className="text-xs sm:text-sm text-slate-700 cursor-pointer"
                                        >
                                            Implant
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Note Section */}
                        <div className="border-t pt-3 sm:pt-4 mt-3 sm:mt-4">
                            <label className="block text-xs sm:text-sm font-medium text-slate-700 mb-1.5 sm:mb-2">
                                Note
                            </label>
                            <textarea
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                onBlur={(e) => handleNoteChange(e.target.value)}
                                placeholder="Add a note for this tooth..."
                                className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xs sm:text-sm resize-none"
                                rows={3}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-2 px-3 py-2 sm:px-4 sm:py-2 md:px-5 md:py-2.5 border-t border-slate-200 bg-white flex-shrink-0">
                    <button
                        onClick={onClose}
                        className="flex-1 px-3 sm:px-4 py-1.5 sm:py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-50 transition-colors text-xs sm:text-sm font-medium"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}

                        className="flex-1 px-3 sm:px-4 py-1.5 sm:py-2  bg-gradient-to-r text-white rounded-lg from-primary to-primaryLight transition-colors text-xs sm:text-sm font-medium"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ToothDiagnoseModal